export const homeReducer = (state = { home: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'HOME_REQUEST':
            return { loading: true, home: {} }
        case 'HOME_SUCCESS':
            return { loading: false, home: action.payload }
        default:
            return state;
    }
}

export const pageReducer = (state = { page: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'PAGE_REQUEST':
            return { loading: true, page: {} }
        case 'PAGE_SUCCESS':
            return { loading: false, page: action.payload }
        default:
            return state;
    }
}

export const submitPaymentReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'SUBMIT_PAYMENT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'SUBMIT_PAYMENT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'SUBMIT_PAYMENT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'SUBMIT_PAYMENT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const loginReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'LOGIN_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'LOGIN_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'LOGIN_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'LOGIN_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const registerReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'REGISTER_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'REGISTER_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'REGISTER_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'REGISTER_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const activationReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'ACTIVATION_ACCOUNT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'ACTIVATION_ACCOUNT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'ACTIVATION_ACCOUNT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'ACTIVATION_ACCOUNT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const sendActivationReducer = (state = { resp2: null, form_loading2: false }, action: any) => {
    switch (action.type) {
        case 'SEND_ACTIVATION_CODE_POST_REQUEST':
            return { form_loading2: true, resp2: null }
        case 'SEND_ACTIVATION_CODE_POST_SUCCESS':
            return { form_loading2: false, resp2: action.payload }
        case 'SEND_ACTIVATION_CODE_POST_ERROR':
            return { form_loading2: false, resp2: null }
        case 'SEND_ACTIVATION_CODE_POST_RESET':
            return { form_loading2: false, resp2: null }
        default:
            return state;
    }
}

export const passwordRecoveryReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'PASSWORD_RECOVERY_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'PASSWORD_RECOVERY_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'PASSWORD_RECOVERY_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'PASSWORD_RECOVERY_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const changePasswordReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'CHANGE_PASSWORD_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'CHANGE_PASSWORD_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'CHANGE_PASSWORD_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'CHANGE_PASSWORD_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const categoryCampaignsReducer = (state = { campaigns: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CATEGORY_CAMPAIGNS_REQUEST':
            return { loading: true, campaigns: {} }
        case 'CATEGORY_CAMPAIGNS_SUCCESS':
            return { loading: false, campaigns: action.payload }
        case 'CATEGORY_CAMPAIGNS_ERROR':
            return { loading: false, campaigns: {} }
        case 'CATEGORY_CAMPAIGNS_RESET':
            return { loading: false, campaigns: {} }
        default:
            return state;
    }
}

export const productListReducer = (state = { products: [] }, action: any) => {
    switch (action.type) {
        case 'PRODUCT_LIST_REQUEST':
            return { loading: true, products: [] }
        case 'PRODUCT_LIST_SUCCESS':
            return { loading: false, products: action.payload }
        default:
            return state;
    }
}

export const productViewReducer = (state = { productView: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'PRODUCT_VIEW_REQUEST':
            return { loading: true, productView: {} }
        case 'PRODUCT_VIEW_SUCCESS':
            return { loading: false, productView: action.payload }
        case 'PRODUCT_VIEW_ERROR':
            return { loading: false, productView: {} }
        case 'PRODUCT_VIEW_RESET':
            return { loading: true, productView: {} }
        default:
            return state;
    }
}

export const productCommentsReducer = (state = { productComments: {}, loading1: true }, action: any) => {
    switch (action.type) {
        case 'PRODUCT_COMMENTS_REQUEST':
            return { loading1: true, productComments: {} }
        case 'PRODUCT_COMMENTS_SUCCESS':
            return { loading1: false, productComments: action.payload }
        default:
            return state;
    }
}

export const orderDetailReducer = (state = { orderDetail: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'ORDER_DETAIL_GET_REQUEST':
            return { loading: true, orderDetail: {} }
        case 'ORDER_DETAIL_GET_SUCCESS':
            return { loading: false, orderDetail: action.payload }
        case 'ORDER_DETAIL_GET_ERROR':
            return { loading: false, orderDetail: {} }
        case 'ORDER_DETAIL_GET_RESET':
            return { loading: false, orderDetail: {} }
        default:
            return state;
    }
}

export const orderListReducer = (state = { orders: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'ORDER_LIST_GET_REQUEST':
            return { loading: true, orders: {} }
        case 'ORDER_LIST_GET_SUCCESS':
            return { loading: false, orders: action.payload }
        case 'ORDER_LIST_GET_ERROR':
            return { loading: false, orders: {} }
        case 'ORDER_LIST_GET_RESET':
            return { loading: false, orders: {} }
        default:
            return state;
    }
}


export const evetViewReducer = (state = { eventView: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'EVENT_VIEW_REQUEST':
            return { loading: true, eventView: {} }
        case 'EVENT_VIEW_SUCCESS':
            return { loading: false, eventView: action.payload }
        case 'EVENT_VIEW_ERROR':
            return { loading: false, eventView: {} }
        case 'EVENT_VIEW_RESET':
            return { loading: true, eventView: {} }
        default:
            return state;
    }
}

export const evetRegViewReducer = (state = { eventRegView: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'EVENT_REG_VIEW_REQUEST':
            return { loading: true, eventRegView: {} }
        case 'EVENT_REG_VIEW_SUCCESS':
            return { loading: false, eventRegView: action.payload }
        case 'EVENT_REG_VIEW_ERROR':
            return { loading: false, eventRegView: {} }
        case 'EVENT_REG_VIEW_RESET':
            return { loading: true, eventRegView: {} }
        default:
            return state;
    }
}

export const eventRegisterReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'REGISTER_EVENT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'REGISTER_EVENT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'REGISTER_EVENT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'REGISTER_EVENT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const fundGetReducer = (state = { fund: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'FUND_GET_REQUEST':
            return { loading: true, fund: {} }
        case 'FUND_GET_SUCCESS':
            return { loading: false, fund: action.payload }
        case 'FUND_GET_ERROR':
            return { loading: false, fund: {} }
        case 'FUND_GET_RESET':
            return { loading: false, fund: {} }
        default:
            return state;
    }
}

export const messageListReducer = (state = { messages: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'MESSAGE_LIST_GET_REQUEST':
            return { loading: true, messages: {} }
        case 'MESSAGE_LIST_GET_SUCCESS':
            return { loading: false, messages: action.payload }
        case 'MESSAGE_LIST_GET_ERROR':
            return { loading: false, messages: {} }
        case 'MESSAGE_LIST_GET_RESET':
            return { loading: false, messages: {} }
        default:
            return state;
    }
}

export const messageViewReducer = (state = { message: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'MESSAGE_VIEW_GET_REQUEST':
            return { loading: true, message: {} }
        case 'MESSAGE_VIEW_GET_SUCCESS':
            return { loading: false, message: action.payload }
        case 'MESSAGE_VIEW_GET_ERROR':
            return { loading: false, message: {} }
        case 'MESSAGE_VIEW_GET_RESET':
            return { loading: false, message: {} }
        default:
            return state;
    }
}

export const submitMessageReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'SUBMIT_MESSAGE_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'SUBMIT_MESSAGE_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'SUBMIT_MESSAGE_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'SUBMIT_MESSAGE_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const paymentsReducer = (state = { payments: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'PAYMENT_LIST_GET_REQUEST':
            return { loading: true, payments: {} }
        case 'PAYMENT_LIST_GET_SUCCESS':
            return { loading: false, payments: action.payload }
        case 'PAYMENT_LIST_GET_ERROR':
            return { loading: false, payments: {} }
        case 'PAYMENT_LIST_GET_RESET':
            return { loading: false, payments: {} }
        default:
            return state;
    }
}

export const getCartReducer = (state = { cart: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CART_GET_REQUEST':
            return { loading: true, cart: {} }
        case 'CART_GET_SUCCESS':
            return { loading: false, cart: action.payload }
        case 'CART_GET_ERROR':
            return { loading: false, cart: {} }
        case 'CART_GET_RESET':
            return { loading: false, cart: {} }
        default:
            return state;
    }
}

export const addCartReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'ADD_CART_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'ADD_CART_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'ADD_CART_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'ADD_CART_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const removeCartReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'REMOVE_CART_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'REMOVE_CART_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'REMOVE_CART_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'REMOVE_CART_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const changeCartReducer = (state = { resp2: null, form_loading2: false }, action: any) => {
    switch (action.type) {
        case 'CHANGE_CART_POST_REQUEST':
            return { form_loading2: true, resp2: null }
        case 'CHANGE_CART_POST_SUCCESS':
            return { form_loading2: false, resp2: action.payload }
        case 'CHANGE_CART_POST_ERROR':
            return { form_loading2: false, resp2: null }
        case 'CHANGE_CART_POST_RESET':
            return { form_loading2: false, resp2: null }
        default:
            return state;
    }
}

export const applyCouponReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'APPLY_COUPON_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'APPLY_COUPON_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'APPLY_COUPON_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'APPLY_COUPON_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const submitCartReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'SUBMIT_CART_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'SUBMIT_CART_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'SUBMIT_CART_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'SUBMIT_CART_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addReminderReducer = (state = { resp2: null, form_loading2: false }, action: any) => {
    switch (action.type) {
        case 'ADD_REMINDER_POST_REQUEST':
            return { form_loading2: true, resp2: null }
        case 'ADD_REMINDER_POST_SUCCESS':
            return { form_loading2: false, resp2: action.payload }
        case 'ADD_REMINDER_POST_ERROR':
            return { form_loading2: false, resp2: null }
        case 'ADD_REMINDER_POST_RESET':
            return { form_loading2: false, resp2: null }
        default:
            return state;
    }
}

export const donationDoReducer = (state = { donationDo: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'DONATION_DO_GET_REQUEST':
            return { loading: true, donationDo: {} }
        case 'DONATION_DO_GET_SUCCESS':
            return { loading: false, donationDo: action.payload }
        case 'DONATION_DO_GET_ERROR':
            return { loading: false, donationDo: {} }
        case 'DONATION_DO_GET_RESET':
            return { loading: true, donationDo: {} }
        default:
            return state;
    }
}

export const campaignViewReducer = (state = { campaignView: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_VIEW_REQUEST':
            return { loading: true, campaignView: {} }
        case 'CAMPAIGN_VIEW_SUCCESS':
            return { loading: false, campaignView: action.payload }
        case 'CAMPAIGN_VIEW_ERROR':
            return { loading: false, campaignView: {} }
        case 'CAMPAIGN_VIEW_RESET':
            return { loading: true, campaignView: {} }
        default:
            return state;
    }
}

export const campaignTreeDocumentsReducer = (state = { documents: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_TREE_DOCS_REQUEST':
            return { loading: true, documents: {} }
        case 'CAMPAIGN_TREE_DOCS_SUCCESS':
            return { loading: false, documents: action.payload }
        // case 'CAMPAIGN_VIEW_ERROR':
        //     return { loading: false, docs: {} }
        // case 'CAMPAIGN_VIEW_RESET':
        //     return { loading: true, docs: {} }
        default:
            return state;
    }
}

export const campaignDownloadDocumentReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_REQUEST':
            return { form_loading: true, resp: null }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_ERROR':
            return { form_loading: false, resp: null }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const campaignDownloadDocumentOldReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_REQUEST':
            return { form_loading: true, resp: null }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_ERROR':
            return { form_loading: false, resp: null }
        case 'CAMPAIGN_DOWNLOAD_DOCUMENT_OLD_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const campaignDeleteTreeDocsReducer = (state = { resp2: null, form_loading2: false }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_DELETE_TREE_DOCUMENT_REQUEST':
            return { form_loading2: true, resp2: null }
        case 'CAMPAIGN_DELETE_TREE_DOCUMENT_SUCCESS':
            return { form_loading2: false, resp2: action.payload }
        case 'CAMPAIGN_DELETE_TREE_DOCUMENT_ERROR':
            return { form_loading2: false, resp2: null }
        case 'CAMPAIGN_DELETE_TREE_DOCUMENT_RESET':
            return { form_loading2: false, resp2: null }
        default:
            return state;
    }
}

export const campaignCommentsReducer = (state = { campaignComments: {}, loading1: true }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_COMMENTS_REQUEST':
            return { loading1: true, campaignComments: {} }
        case 'CAMPAIGN_COMMENTS_SUCCESS':
            return { loading1: false, campaignComments: action.payload }
        default:
            return state;
    }
}

export const campaignDonateSuccessReducer = (state = { donate: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_DONATE_SUCCESS_REQUEST':
            return { loading: true, donate: {} }
        case 'CAMPAIGN_DONATE_SUCCESS_SUCCESS':
            return { loading: false, donate: action.payload }
        default:
            return state;
    }
}

export const campaignDonationsReducer = (state = { campaignDonations: {}, loading2: true }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_DONATIONS_REQUEST':
            return { loading2: true, campaignDonations: {} }
        case 'CAMPAIGN_DONATIONS_SUCCESS':
            return { loading2: false, campaignDonations: action.payload }
        default:
            return state;
    }
}

export const blogViewReducer = (state = { blogView: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'BLOG_VIEW_REQUEST':
            return { loading: true, blogView: {} }
        case 'BLOG_VIEW_SUCCESS':
            return { loading: false, blogView: action.payload }
        case 'BLOG_VIEW_ERROR':
            return { loading: false, blogView: {} }
        case 'BLOG_VIEW_RESET':
            return { loading: true, blogView: {} }
        default:
            return state;
    }
}

export const blogPostsReducer = (state = { blogPosts: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'BLOG_POSTS_REQUEST':
            return { loading: true, blogPosts: {} }
        case 'BLOG_POSTS_SUCCESS':
            return { loading: false, blogPosts: action.payload }
        case 'BLOG_POSTS_ERROR':
            return { loading: false, blogPosts: {} }
        default:
            return state;
    }
}

export const blogCommentsReducer = (state = { blogComments: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'BLOG_COMMENTS_REQUEST':
            return { loading: true, blogComments: {} }
        case 'BLOG_COMMENTS_SUCCESS':
            return { loading: false, blogComments: action.payload }
        case 'BLOG_COMMENTS_ERROR':
            return { loading: false, blogComments: {} }
        default:
            return state;
    }
}

export const donationReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'DONATION_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'DONATION_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'DONATION_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'DONATION_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const contactReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'CONTACT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'CONTACT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'CONTACT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'CONTACT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addCampaignCommentReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'CAMPAIGN_COMMENT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'CAMPAIGN_COMMENT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'CAMPAIGN_COMMENT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'CAMPAIGN_COMMENT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addBlogCommentReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'BLOG_COMMENT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'BLOG_COMMENT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'BLOG_COMMENT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'BLOG_COMMENT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addProductCommentReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'PRODUCT_COMMENT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'PRODUCT_COMMENT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'PRODUCT_COMMENT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'PRODUCT_COMMENT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addDepositReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'DEPOSIT_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'DEPOSIT_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'DEPOSIT_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'DEPOSIT_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addAidReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'AID_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'AID_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'AID_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'AID_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const addRequestCardReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'REQUEST_CARD_POST_REQUEST':
            return { form_loading: true, resp: null }
        case 'REQUEST_CARD_POST_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'REQUEST_CARD_POST_ERROR':
            return { form_loading: false, resp: null }
        case 'REQUEST_CARD_POST_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const userDataReducer = (state = { userData: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'USER_DATA_REQUEST':
            return { loading: true, userData: {} }
        case 'USER_DATA_SUCCESS':
            return { loading: false, userData: action.payload }
        case 'USER_DATA_ERROR':
            return { loading: false, userData: {} }
        case 'USER_DATA_RESET':
            return { loading: false, userData: {} }
        default:
            return state;
    }
}

export const checkAidReducer = (state = { checkAid: {}, loading: true }, action: any) => {
    switch (action.type) {
        case 'CHECK_AID_REQUEST':
            return { loading: true, checkAid: {} }
        case 'CHECK_AID_SUCCESS':
            return { loading: false, checkAid: action.payload }
        case 'CHECK_AID_ERROR':
            return { loading: false, checkAid: {} }
        default:
            return state;
    }
}

export const uploadAvatarReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'UPLOAD_AVATAR_REQUEST':
            return { form_loading: true, resp: null }
        case 'UPLOAD_AVATAR_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'UPLOAD_AVATAR_ERROR':
            return { form_loading: false, resp: null }
        case 'UPLOAD_AVATAR_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const uploadNationalCardReducer = (state = { resp: null, form_loading: false }, action: any) => {
    switch (action.type) {
        case 'UPLOAD_NATIONAL_CARD_REQUEST':
            return { form_loading: true, resp: null }
        case 'UPLOAD_NATIONAL_CARD_SUCCESS':
            return { form_loading: false, resp: action.payload }
        case 'UPLOAD_NATIONAL_CARD_ERROR':
            return { form_loading: false, resp: null }
        case 'UPLOAD_NATIONAL_CARD_RESET':
            return { form_loading: false, resp: null }
        default:
            return state;
    }
}

export const uploadAttachReducer = (state = { resp2: null, form_loading2: false }, action: any) => {
    switch (action.type) {
        case 'UPLOAD_ATTACH_REQUEST':
            return { form_loading2: true, resp2: null }
        case 'UPLOAD_ATTACH_SUCCESS':
            return { form_loading2: false, resp2: action.payload }
        case 'UPLOAD_ATTACH_ERROR':
            return { form_loading2: false, resp2: null }
        case 'UPLOAD_ATTACH_RESET':
            return { form_loading2: false, resp2: null }
        default:
            return state;
    }
}